import { render, staticRenderFns } from "./NewsTrends.vue?vue&type=template&id=1168f62f&scoped=true&"
import script from "./NewsTrends.vue?vue&type=script&lang=js&"
export * from "./NewsTrends.vue?vue&type=script&lang=js&"
import style0 from "./NewsTrends.vue?vue&type=style&index=0&id=1168f62f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1168f62f",
  null
  
)

export default component.exports